//  POEdit.aspx
var PoCreate = (function (backOffice, $) {
    backOffice.PoCreate = (function () {
        const SubmitCreatePO = '#btnCreatePO';
        const SubmitRedirectToPOManager = '#btnGoPOManager';
        const SupplierInvoiceNo = '#new_po_supplier_invoice_no';
        const SupplierSelector = '#new_po_supplier';
        const WarehouseSelector = '#new_po_warehouse';
        var isPOFormSubmitted = false;
        var loadPODropdowns = function (url) {
            return $.ajax({
                url: url,
                timeout: 60000,
                dataType: 'json',
                contentType: 'application/json charset=UTF-8'
            });
        }

        var initPage = function () {

            $(SubmitCreatePO).off('click').click(submitCreatingPO);
            $(SubmitRedirectToPOManager).off('click').click(redirectToPOManager);

            $(document).ajaxStart(function () {
                BackOffice.ToggleLoader(true);
            }).ajaxStop(function () {
                BackOffice.ToggleLoader(false);
            });

            var getPoSuppliersDeferred = loadPODropdowns(window.location.origin + '/dotnet/admin/api/getposuppliers');
            var getPoOutletsDeferred = loadPODropdowns(window.location.origin + '/dotnet/admin/api/getpooutlets');

            getPoSuppliersDeferred
                .done(function (getPoSuppliersResponse) {
                    $(SupplierSelector).html('<option></option>');
                    var poSuppliersData = getPoSuppliersResponse;
                    for (var i = 0; i < poSuppliersData.length; i++) {
                        $('<option/>', {
                            value: poSuppliersData[i].supplierCode,
                            html: poSuppliersData[i].name
                        }).appendTo(SupplierSelector);
                    }
                })
                .fail(function () {
                    alert("Error loading suppliers");
                });

            getPoOutletsDeferred
                .done(function (getPoOutletsResponse) {
                    var poOutletsData = getPoOutletsResponse;
                    $(WarehouseSelector).html('<option></option>');
                    for (var i = 0; i < poOutletsData.length; i++) {
                        $('<option/>', {
                            value: poOutletsData[i].id,
                            html: poOutletsData[i].name
                        }).appendTo(WarehouseSelector);
                    }
                })
                .fail(function () {
                    alert("Error loading outlets");
                });
        }

        var validatePo = function () {
            if (!$.trim($(WarehouseSelector).val()))  {
                alert("Please select an Outlet");
                return false;
            }

            if (!$.trim($(SupplierSelector).val())) {
                alert("Please select a Supplier");
                return false;
            }

            var supplierInvoiceNumber = $(SupplierInvoiceNo).val();
            if (supplierInvoiceNumber && supplierInvoiceNumber.length > 50) {
                alert("Supplier Invoice Number length can't be more than 50");
                return false;
            }
            return true;
        }

        var submitCreatingPO = function (e) {
            if (isPOFormSubmitted) {
                e.preventDefault(); // Stop the form if already submitted
                e.stopPropagation();
                return false;
            }
            isPOFormSubmitted = true;
            $(SubmitCreatePO).attr('disabled', 'disabled');
            if (validatePo()) {
                $.ajax({
                    method: 'POST',
                    async: false,
                    data: JSON.stringify({
                        WarehouseId: $(WarehouseSelector).val(),
                        SupplierCode: $(SupplierSelector).val(),
                        SupplierInvoiceNumber: $(SupplierInvoiceNo).val() ? $(SupplierInvoiceNo).val() : null
                    }),
                    url: window.location.origin + '/dotnet/admin/api/createpo',
                    dataType: 'json',
                    contentType: 'application/json charset=UTF-8',
                    success: function (newProductId) {
                        e.preventDefault();
                        e.stopPropagation();
                        window.location.href = window.location.origin + '/DOTNET/Admin/Inventory/POMaint/POEdit.aspx?ID=' + newProductId + '&WHID=' + $(WarehouseSelector).val() + '&TAB=tabAddItems';
                        return false;
                    },
                    error: function (request, status, error) {
                        isPOFormSubmitted = false;
                        $(SubmitCreatePO).removeAttr('disabled');
                        alert(request.responseJSON.exceptionMessage);
                    }
                })
            }
            else {
                isPOFormSubmitted = false;
                $(SubmitCreatePO).removeAttr('disabled');
                return false;
            }
        };

        var redirectToPOManager = function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = window.location.origin + '/DOTNET/Admin/Inventory/PO.aspx';
            return false;
        };


        return $.extend(backOffice.PoCreate, {
            Init: initPage
        });
    })();


    return backOffice.PoCreate;
})(BackOffice || {}, jQuery);